export enum WarehouseAdminResupplyReason {
    Replacement = "replacement",
    Missing = "missing"
}

export interface IWarehouseAdminResupplyTaskProductData {
    id: number;
    name: string|null;
}

export interface IWarehouseAdminResupplyTaskData {
    id: number;
    building: string|null;
    unit: string|null;
    contract_id: string|null;
    job_id: number|null;
    product_id: number|null;
    product: IWarehouseAdminResupplyTaskProductData|null;
    quantity: number|null;
    reason: WarehouseAdminResupplyReason|null;
    timestamp: string|null;
    user: string|null;
}

export class WarehouseAdminResupplyTaskProductData {
    id: number;
    name: string|null;

    constructor(data: IWarehouseAdminResupplyTaskProductData) {
        this.id = Number(data.id);
        this.name = data.name ?? null;
    }
}

export default class WarehouseAdminResupplyTaskData {
    id: number;
    building: string|null;
    unit: string|null;
    contract_id: string|null;
    job_id: number|null;
    product_id: number|null;
    product: WarehouseAdminResupplyTaskProductData|null;
    quantity: number|null;
    reason: WarehouseAdminResupplyReason|null;
    timestamp: string|null;
    user: string|null;

    constructor(data: IWarehouseAdminResupplyTaskData) {
        this.id = Number(data.id);
        this.building = data.building ?? null;
        this.unit = data.unit ?? null;
        this.contract_id = data.contract_id ?? null;
        this.job_id = data.job_id == null ? null : Number(data.job_id);
        this.product_id = data.product_id == null ? null : Number(data.product_id);
        this.product = data.product
            ? new WarehouseAdminResupplyTaskProductData(data.product)
            : null;
        this.quantity = data.quantity == null ? null : Number(data.quantity);
        this.reason = data.reason ?? null;
        this.timestamp = data.timestamp ?? null;
        this.user = data.user ?? null;
    }
}